import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess40606Status: 'idle',
    startProcess40606Error: undefined as any,
    loadUserParamsProcess40606Status: 'idle',
    loadUserParamsProcess40606Error: undefined as any,

    process40606List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess40606 = createAsyncThunk('process40606Slice/startProcess40606', async ({ process40606 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess40606/`,
        prepareData(process40606),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess40606Status } = getState().process40606Slice
        return startProcess40606Status !== 'pending'
    }
})

export const loadUserParamsProcess40606 = createAsyncThunk('process40606Slice/loadUserParamsProcess40606', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess40606/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess40606Status } = getState().process40606Slice
        return loadUserParamsProcess40606Status !== 'pending'
    }
})

const Process40606Slice = createSlice({
    name: 'process40606Slice',
    initialState,
    reducers: {
        resetstartProcess40606: (state) => {
            state.job = undefined
            state.startProcess40606Error = undefined
        },
        resetstartProcess40606Error: (state) => {
            state.startProcess40606Error = undefined
        },
        resetloadUserParamsProcess40606: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess40606Error = undefined
        },
        resetloadUserParamsProcess40606Error: (state) => {
            state.loadUserParamsProcess40606Error = undefined
        },
        removeFromProcess40606ListById: (state, action) => {
            state.process40606List = state.process40606List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess40606ListByIds: (state, action) => {
            state.process40606List = state.process40606List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process40606List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess40606Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process40606List = []
            state.startProcess40606Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess40606.pending, (state) => {
            state.startProcess40606Status = 'pending'
            state.startProcess40606Error = undefined
        })
        builder.addCase(startProcess40606.fulfilled, (state, action) => {
            state.startProcess40606Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess40606.rejected, (state, action) => {
            state.startProcess40606Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess40606Error = action.error.message
            } else {
                state.startProcess40606Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess40606.pending, (state) => {
            state.loadUserParamsProcess40606Status = 'pending'
            state.loadUserParamsProcess40606Error = undefined
        })
        builder.addCase(loadUserParamsProcess40606.fulfilled, (state, action) => {
            state.loadUserParamsProcess40606Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess40606.rejected, (state, action) => {
            state.loadUserParamsProcess40606Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess40606Error = action.error.message
            } else {
                state.loadUserParamsProcess40606Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess40606,
    resetstartProcess40606Error,
    resetloadUserParamsProcess40606,
    resetloadUserParamsProcess40606Error,
    removeFromProcess40606ListById,
    removeFromProcess40606ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process40606Slice.actions
export default Process40606Slice.reducer
